import { Link } from "react-router-dom";

function Logo({ src, alt }) {
  return (
    <div className="w-full flex justify-start px-4 py-2">
      <Link to="/">
        <img
          src={src}
          alt={alt}
          className="h-12 md:h-16 w-auto object-contain cursor-pointer"
        />
      </Link>
    </div>
  );
} 

export default Logo;
